module.exports = __webpack_public_path__ + "static/media/0357_Medium.cf316766.jpg";